let k = 1;
export function generateUniqueKey(place?: string) {
  return `${place || "comp"}.${k++}`;
}
